


import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';

export async function getLocationAPI ({  apiKey, traceId, store}) {
    return await api.get(
        `${endpoints().location}?apiKey=${apiKey}`,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function getOptinAPI ({  apiKey, traceId, store, locale}) {
    return await api.get(
        `${endpoints().optin}?apiKey=${apiKey}&locale=${locale}`,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function  trackWithDataAPI ({  apiKey, body, traceId, store, locale}) {
    return await api.post(
        `${endpoints().data}?apiKey=${apiKey}&locale=${locale}`,
        body,
        { traceId }, /* options */
        store,
    );  
}
